export default {
  label: {
    insertImage: 'Inserir imagem',
    insertFile: 'Inserir arquivo',
    insertLink: 'Inserir link de imagem',
    link: 'Link',
    cancel: 'Cancelar',
    select: 'Selecionar',
  },
};
